import React from 'react';
import cm from 'classnames';
import type { ColumnInterface } from 'ksnm-common-ui/lib/Table2/Table.interface';
import type { FieldFormat, ResponseDataRows } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { constantStore } from '@stores/constantStore';
import type { PeriodDto } from '@src/api';

import styles from './PublicationRegister.module.scss';

const { PUBLISHED, NEEDS_IMPROVEMENT } = constantStore.REPORT_PACKAGE_STATUS;

export const getColumns = (localData: ResponseDataRows, periods: PeriodDto[]): ColumnInterface[] => [
  {
    key: 'name1',
    title: 'Организация',
    groupBy: 10,
    hidden: true,
  },
  {
    key: 'name2',
    title: 'Год',
    groupBy: 20,
    hidden: true,
  },
  {
    key: 'name3',
    title: 'Код группы',
    groupBy: 30,
    hidden: true,
  },
  {
    key: 'name4',
    title: 'Код пакета',
    groupBy: 40,
    hidden: true,
  },
  {
    key: 'name5',
    title: 'Журнал',
    groupBy: 50,
    hidden: true,
  },
  {
    key: 'reportPackageStatus',
    title: 'Статус',
    width: 250,
    render: ({ data }) => {
      let status = data.reportPublishStatus;

      if (data.is_group && data.level === 4) {
        const found = localData?.find((f) => f.name4 === data.name4);

        if (found) status = found.reportPackageStatus;
      }

      return (
        <div
          className={cm({
            [styles.blue]: status === PUBLISHED,
            [styles.yellow]: status === NEEDS_IMPROVEMENT,
          })}
        >
          {status}
        </div>
      );
    },
  },
  {
    key: 'reportName',
    title: 'Наименование',
  },
  {
    key: 'periodCode',
    title: 'Период',
    width: 150,
    render: ({ data }) => {
      if (data.is_group && data.level === 4) {
        const found = localData?.find((f) => f.name4 === data.name4);

        if (found) {
          const period = periods.find((item) => item.code === found.periodCode);
          return period ? `${period.code} - ${period.name}` : '';
        }
      }
    },
  },
  {
    key: 'reportPackageCorrection',
    title: 'Версия',
    width: 180,
    render: ({ data }) => {
      if (data.is_group && data.level === 4) {
        const found = localData?.find((f) => f.name4 === data.name4);

        if (found) return found.reportPackageCorrection;
      }
    },
  },
  {
    key: 'uploadDate',
    title: 'Дата загрузки',
    width: 180,
  },
  {
    key: 'reportPublishUser',
    title: 'Пользователь',
    width: 300,
    render: ({ value, data }) => {
      if (data.is_group && data.level === 4) {
        const found = localData?.find((f) => f.name4 === data.name4);

        if (found) return found.reportPackageUser;
      }

      return value;
    },
  },
];

export const fieldFormat: { [index: string]: FieldFormat } = {
  id: 'number',
  reportTypeOrder: 'number',
  name: 'string',
  reportPackageCode: 'string',
  reportPackageStatus: 'string',
  reportGroupCode: 'string',
  periodCode: 'string',
  reportPackageName: 'string',
  reportPackageCorrection: 'string',
  reportPackageYear: 'number',
  preparationMonth: 'number',
  preparationDay: 'number',
  disclosureMonthCode: 'number',
  dueDay: 'number',
  reportPublishDate: 'string',
  reportPackageUser: 'string',
  reportPackageDeclarationRegNumber: 'string',
  organization: 'string',
  reportCodeExt: 'string',
  reportPublishStatus: 'string',
  reportName: 'string',
  infoSystemCode: 'string',
  reportPublishUser: 'string',
  buildDate: 'string',
  uploadDate: 'string',
  organizationCode: 'string',
  reportVersionCode: 'string',
  reportVersionName: 'string',
  reportCode: 'string',
  taxTypeCode: 'string',
  taxTypeName: 'string',
  reportTypeCode: 'string',
  reportVersionVersion: 'string',
  orderNum: 'number',
  name1: 'string',
  name2: 'string',
  name3: 'string',
  name4: 'string',
  name5: 'string',
};
